import React from "react";
import { Box } from "@mui/material";
import { TravelAssistanceStyles } from "../Styles";
import GlobalLaunching from "../../components/GlobalLaunching";

const IncomeProtect = () => {
  return (
    <Box m={10} sx={[TravelAssistanceStyles.MainBannerBox]}>
      <GlobalLaunching />
    </Box>
  );
};

export default IncomeProtect;
